import DataTile from "./DataTile";
import {fetchTargets} from "../../../actions";
import React from "react";
import {useSelector} from "react-redux";
import BBIconNetworkNodes from "../../../assets/bbCustomIcons/BBIconNetworkNodes";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].targets : null : null;

    // const translateValueToRisk = (value) => {
    //     if (typeof value !== "number") {
    //         return null
    //     } else if (value <= 5) {
    //         return 0
    //     } else if (value <= 15) {
    //         return 1
    //     } else if (value <= 24) {
    //         return 2
    //     } else if (value <= 40) {
    //         return 3
    //     } else {
    //         return 4
    //     }
    // }

    // const colorFunction = (stateData) => {
    //     const num = valueFunction(stateData);
    //     return bbTranslateRiskToColor(translateValueToRisk(num));
    // }

    // const riskRibbon = (stateData) => {
    //     const num = translateValueToRisk(valueFunction(stateData));
    //     return num
    //         ? <RiskRibbon ratingBy5={num} />
    //         : null;
    // }

    return (
        <DataTile
            color="light"
            subTitle="System Targets"
            tipText={`All network hosts detected from the attacker's vantage point.`}
            icon={<BBIconNetworkNodes style={{fontSize: "70px"}}/>}
            stateName="customer"
            stateElement="metaTargets"
            // useDeepDataStore
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].targets : null : null}
            stateLoaderName="loadingTargets"
            stateLoaderError="loadingTargetsError"
            stateFetchAction={fetchTargets(
                {
                    customerId: customerIdToUse
                }
            )}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={null}
            requiresModule={"monitor"}
        />
    )

}

export default Tile;